<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <img src="https://onedio.com/images/logo/onedio-new2x-new.png" width="250" height="70">
      </b-row>
      <b-row class="justify-content-center mt-3">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input v-model="username" type="text" class="form-control" placeholder="Username" autocomplete="username email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input v-on:keyup.enter="getUser" v-model="password" type="password" class="form-control" placeholder="Password" autocomplete="current-password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                     
                    <vue-button-spinner  
                      :is-loading="isLoading" 
                      :disabled="isLoading"
                      :status="status"
                      v-on:click.native="onSubmit"
                      >
                      <span  variant="primary" class="px-4" > Login </span>
                      <!-- <b-button @click="onSubmit" variant="primary" class="px-4">Login</b-button> -->
                  </vue-button-spinner>   
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import JWT from 'jsonwebtoken'
import VueButtonSpinner from 'vue-button-spinner';
import getProfilePhoto from '../../plugins/getProfilePhoto'
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      isLoading:false,
      status: '',
    }
  },
  components: {	
    VueButtonSpinner
  },
  beforeCreate(){
    const token = $cookies.get('user')
    if(token){
      JWT.verify(token, this.$store.state.jwtToken, (err, decode) => {
        if (err) {
          console.log('Token expired!')
        } else {
          this.$router.push('/dashboard')
        }
      })
    }
  },
  methods: {
   onSubmit() {
      this.isLoading = true
      axios.post(`${this.$store.state.backend}/login`,{
        username:this.username,
        password: this.password
      }).then(async result => {
          this.isLoading = false
          this.status = true // or success
          setTimeout(() => { this.status = '' }, 2000) // to clear the status :)
          if(result.data.status){
          $cookies.set('user',result.data.token)
          this.$store.dispatch('SET_REQUEST')
          await $cookies.set('username',this.username)
          //set username
          await this.$events.fire('SET_USERNAME',this.username );
          //get profile photo 
          let inactive=false
          await this.$store.dispatch('SET_BUTTON_ACTIVES',{a: inactive, b: true, c: inactive,d:inactive,e:inactive})
          this.$router.push('/dashboard')
        }else{
           this.isLoading = false
          this.status = false //or error
          alert('Wrong username or password!')
        } 
      })
      .catch(error => {
          console.error(error)
          this.isLoading = false
          this.status = false //or error
      })
  },

   async getUser(){
      axios.post(`${this.$store.state.backend}/login`,{
        username:this.username,
        password: this.password
      }).then(async (result) => {
        this.isLoading=true
        if(result.data.status){
          let username=this.username
          $cookies.set('user',result.data.token)
          await $cookies.set('username',username)
          await this.$store.dispatch('SET_REQUEST')
          //set username
          await this.$events.fire('SET_USERNAME', username );
          //get profile photo 
          let inactive=false
          await this.$store.dispatch('SET_BUTTON_ACTIVES',{a: inactive, b: true, c: inactive,d:inactive,e:inactive})
          await this.$router.push('/dashboard')
        }else{
           this.isLoading = false
          this.status = false //or error
        } 
      })
    }
  },
}
</script>
